import React, { useState, useEffect } from "react";
import { PostApi, GetApi, PutApi, getProfCliente, getDocCliente } from "../../services/auth.js";
import { Loading } from "../../helpers";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "../../componentes/ModalLegacy";
import { Cont } from "./styles";
import { Card, CardBody, Grid, Section, InputContainer, FormLabel, Alert, Container, CardFooter, CardHeader} from "uikit-react";
import { DateFormatTNew, visible, formatCnpjCpf, validaCPF, validarCNPJ } from "../../services/funcoes";
import ReactPaginate from 'react-paginate';
import Select from 'react-select'
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';

const Estabelecimentos = () => {
  const ListaStatus = [
    { value: 22076, label: 'Ativo' },
    { value: 22077, label: 'Bloqueado' }
  ];
  const [ListaEstabelecimento, setListaEstabelecimento] = useState(false);
  const [RazaoSocialFiltro, setRazaoSocialFiltro] = useState("");
  const [StatusFiltro, setStatusFiltro] = useState(null);
  const [TipoFiltro, setTipoFiltro] = useState(null);
  const [DataCadInicio, setDataCadInicio] = useState("");
  const [DataCadTermino, setDataCadTermino] = useState("");
  const [CNPJFiltro, setCNPJFiltro] = useState("");
  const [ModalAlteraStatus, setModalAlteraStatus] = useState(false);
  const [NomeEstabelecimentoAlteraStatus, setNomeEstabelecimentoAlteraStatus] = useState("");
  const [DadosEstabelecimento, setDadosEstabelecimento] = useState("");
  const [ModalCadastroEstabelecimento, setModalCadastroEstabelecimento] = useState(false);
  const [DadosCadastro, setDadosCadastro] = useState({});
  const [ListaTipo, setListaTipo] = useState([]);
  const [LoadingCEP, setLoadingCEP] = useState(false);
  const [LoadingExportar, setLoadingExportar] = useState(false);

  //mensagem 
  const [mensagem, Setmensagem] = useState("Nenhuma informação encontrada. Por favor, verifique o filtro aplicado e tente novamente.");

  //Alert
  const [msg, SetMsg] = useState("");
  const [time, SetTime] = useState("");
  const [color, SetColor] = useState(""); //sucess, danger, warning
  const [AlertMsg, SetAlertMsg] = useState(false); 

  //Paginação
  const [itensPerPage, SetItensPerPage] = useState(25);
  const [currentPage, SetCurrentPage] = useState(1);
  const [pageCount, SetPageCount] = useState(0);
  const [pageTotal, SePageTotal] = useState(0);

  const MudaPaginaItens = async (e) => {  
    if(!isNaN(e.nextSelectedPage+1)){      
      SetCurrentPage(e.nextSelectedPage+1)
    }
  }; 

  useEffect(() => {
    GetListaEstabelecimentos();
  },[currentPage, itensPerPage]);  
  
  useEffect(() => {  
    window.scrollTo(0, 0); 
  },[currentPage, itensPerPage]);
  
  useEffect(() => {  
    GetListaTipos();
  },[]);
  
  const GetListaTipos = async () => {
    const response = await GetApi('Cliente/ListaEspecificacoes?tipo=2900');
    if (response.status === 200) {
      setListaTipo(response.data.dados);    
    }    
  };
  
  const GetListaEstabelecimentos = async () => {  
    setListaEstabelecimento(false);

    var FiltrosURL = "";
    if(RazaoSocialFiltro){
      FiltrosURL = FiltrosURL + "RazaoSocial=" + RazaoSocialFiltro.trim() + "&";
    }
    if(StatusFiltro){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCadInicial=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataCadFinal=" + DataCadTermino + "&";
    }
    if(CNPJFiltro){
      FiltrosURL = FiltrosURL + "Documento=" + CNPJFiltro.replace(/\D/g, "") + "&";
    }

    const response = await GetApi('Admin/estabelecimento/?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {
      setListaEstabelecimento(response.data.estabelecimentos);
			SetPageCount(Math.ceil(response.data.totalRegistros / itensPerPage));
			SePageTotal(response.data.totalRegistros)
    } else {
      setListaEstabelecimento([])
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }     
    
  };

  const AbreModalStatusEstabelecimento = async (dados) => {    
    setNomeEstabelecimentoAlteraStatus(dados.nome);
    setDadosEstabelecimento(dados);
    setModalAlteraStatus(true);
  };

  const FechaModalStatusEstabelecimento = () => {    
    setNomeEstabelecimentoAlteraStatus("");
    setDadosEstabelecimento("");
    setModalAlteraStatus(false);
  };

  const AlterarStatusEstabelecimento = async (dados) => {
    var dados = {
      entCod: dados.entCod
    }
    const response = await PutApi('Admin/estabelecimento/status', dados);
    if (response.status === 200) {
      GetListaEstabelecimentos();
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
    }
  };

  const AbreModalCadastroEstabelecimento = () => {
    setDadosCadastro({});
    setModalCadastroEstabelecimento(true);
  };

  const FechaModalCadastroEstabelecimento = () => {
    setDadosCadastro({});
    setModalCadastroEstabelecimento(false);
  };

  const CadastrarEstabelecimento = async () => {

		const VerificaEmail = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    if(!DadosCadastro?.cnpj){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um CNPJ.",
			});
			return;
    }
    if(!validarCNPJ(DadosCadastro?.cnpj)){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um CNPJ válido.",
			});
      return;
    }
    if(!DadosCadastro?.razaoSocial){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe uma razão social.",
			});
      return;
    }
    if(!DadosCadastro?.nomeFantasia){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um nome fantasia.",
			});
      return;
    }
    if(!DadosCadastro?.email){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um e-mail.",
			});
      return;
    }
    if(!VerificaEmail.test(DadosCadastro?.email)) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Você precisa informar um e-mail válido. Exemplo: nome@dominio.com.",
			});
			return;
		}
    var ValidaTelefone = DadosCadastro?.telefone?.replace(/\D/g, "");
    console.log("ValidaTelefone: ", ValidaTelefone);
    if(!ValidaTelefone || ValidaTelefone.length < 10){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um telefone válido.",
			});
      return;
    }

    if(!DadosCadastro?.cep){
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, informe um CEP.",
      });
      return;
    }

    if(!DadosCadastro?.numero){
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, informe um número.",
      });
      return;
    }
    

		visible('btn-envia-formulario-loading');
    visible('btn-envia-formulario');

    var DDDTelefone = ValidaTelefone.substring(0, 2);
    var Telefone = ValidaTelefone.substring(2);

    var dados = {
      "cnpj": DadosCadastro?.cnpj.replace(/\D/g, ""),
      "razaoSocial": DadosCadastro?.razaoSocial,
      "nomeFantasia": DadosCadastro?.nomeFantasia,
      "email": DadosCadastro?.email,
      "dddTelefoneComercial": Number(DDDTelefone),
      "telefoneComercial": Number(Telefone),
      "origem": 6232,
      "cep": DadosCadastro?.cep?.replace(/\D/g, ""),
      "numero": Number(DadosCadastro?.numero),
      "rua": DadosCadastro?.endereco,
      "complemento": DadosCadastro?.complemento,
      "bairro": DadosCadastro?.bairro,
      "cidade": DadosCadastro?.cidade,
      "estado": DadosCadastro?.estado
    }

    console.log('dados: ', dados);

    // return

    const response = await PostApi('Admin/estabelecimento', dados);
    if (response.status === 200) {
      GetListaEstabelecimentos();
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);
      setModalCadastroEstabelecimento(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
      setDadosCadastro({});
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
      setModalCadastroEstabelecimento(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
      setDadosCadastro({});
    }
  };

  const ConsultaCEP = async () => {

    var CEP = DadosCadastro?.cep.replace(/\D/g, "");

    if (!CEP) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, informe um CEP.",
      });
      return;
    }

    if (CEP.length < 8) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, informe um CEP válido.",
      });
      return;
    }

    setLoadingCEP(true);
    setDadosCadastro({
      ...DadosCadastro,
      endereco: null,
      bairro: null,
      cidade: null,
      estado: null,
      numero: null,
      complemento: null
    })
    const response = await GetApi('Transp/ConsultaCEP/' + CEP);
    if (response.status === 200) {

      setDadosCadastro({
        ...DadosCadastro,
        endereco: response.data.end,
        bairro: response.data.bairro,
        cidade: response.data.cidade,
        estado: response.data.uf
      })

      setTimeout(() => {
        setLoadingCEP(false);
      }, 2000);

    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, verifique o CEP informado.",
      });
      setDadosCadastro({
        ...DadosCadastro,
        endereco: null,
        bairro: null,
        cidade: null,
        estado: null,
        numero: null,
        complemento: null
      })
      setLoadingCEP(false);
    }
  }

  const ExportarDados = async () => {

    var FiltrosURL = "";
    if(RazaoSocialFiltro){
      FiltrosURL = FiltrosURL + "RazaoSocial=" + RazaoSocialFiltro.trim() + "&";
    }
    if(StatusFiltro){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCadInicial=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataCadFinal=" + DataCadTermino + "&";
    }
    if(CNPJFiltro){
      FiltrosURL = FiltrosURL + "Documento=" + CNPJFiltro.replace(/\D/g, "") + "&";
    }

    setLoadingExportar(true);
    const response = await GetApi('Admin/estabelecimento/excel?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {

    try {

      const base64 = response.data.arquivoExcel;
      const binaryString = window.atob(base64);
      const byteNumbers = new Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) { byteNumbers[i] = binaryString.charCodeAt(i); }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Estabelecimentos.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } catch (err) {
      console.error("Erro ao processar o Excel:", err);
      SetMsg("Erro ao processar o arquivo Excel.");
      SetColor("danger");
      SetAlertMsg(true);
      setLoadingExportar(false);
    }

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } else {
      setLoadingExportar(false);
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }
  };

  return (
    <Cont>    

      <Container size="expand" className="content-padder content-padder-inative" id="padder" >            
        <main className="uk-section">
          <Section className="uk-container uk-container-xlarge">  

              <Grid className="uk-flex uk-flex-middle uk-margin-medium">                
                <Section className="uk-width-expand">
                  <Section className="uk-inline">
                    <a className="uk-link-heading uk-flex uk-flex-middle">
                        <h4 className="uk-link-toggle uk-text-bold uk-margin-remove">
                          Estabelecimentos
                        </h4>
                        {/* <span uk-icon="icon: menu-down"></span> */}
                    </a>
                  </Section>
                </Section>
              </Grid>  
                    
              <Card className="uk-margin-medium-bottom">
                <CardBody>
                  <Grid className="uk-grid-small">     

                    <Section className="uk-width-1-4@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">CNPJ</FormLabel>
                        <InputMask mask="99.999.999/9999-99" maskChar=" " value={CNPJFiltro} onChange={(e) => setCNPJFiltro(e.target.value)}>
                          {() => (<input type="text" className="uk-input input" placeholder='' />)}
                        </InputMask>                                              
                      </InputContainer>
                    </Section>                 
                
                    <Section className="uk-width-1-4@m">
                      <FormLabel className="uk-form-label">Razão social</FormLabel>
                      <InputContainer>
                        <input
                          className="uk-input input"
                          type="text"
                          value={RazaoSocialFiltro}
                          onChange={e => setRazaoSocialFiltro(e.target.value)}
                        />
                      </InputContainer>
                    </Section>

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro (De)</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadInicio}                    
                            onChange={e => setDataCadInicio(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro (Até)</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadTermino}                    
                            onChange={e => setDataCadTermino(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Status</FormLabel>  
                          <Select           
                            defaultValue={StatusFiltro}
                            onChange={setStatusFiltro}
                            options={ListaStatus}                                            
                            placeholder={"..."}
                            isLoading={!ListaStatus.length}
                            className="basic-multi-select" 
                            classNamePrefix="uk-select"                                                                              
                          />  
                      </InputContainer>
                    </Section>

                  </Grid>                              
                </CardBody>
              
                <CardFooter>
                  <Grid className="uk-grid-small uk-flex uk-flex-right">
                    <Section>
                      <button
                        type="button"                                            
                        id="Filtrar" 
                        className="uk-button uk-button-primary uk-float-right"                          
                        onClick={() => {GetListaEstabelecimentos("Filtrar", "aguardeFiltro"); SetCurrentPage(1)}}        
                        value="Filtrar"   
                        //disabled={blockFiltro}                   
                      > 
                      <span  uk-icon="icon: search"></span> 
                        Filtrar                                        
                      </button>  

                      <button className="uk-button uk-button-primary" id="aguardeFiltro" style={{display:'none'}}>
                        <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                      </button>  

                    </Section>
                  </Grid>                                                           
                </CardFooter> 
              </Card>                
            
              { AlertMsg === true && <Alert color={color} content={msg}  duration={time} onHide={() => SetAlertMsg(false)} isClosable /> } 

              <Card className="uk-card-default uk-margin">

                <CardHeader>
                  <Grid className="uk-flex uk-flex-middle">
                    <Section className="uk-width-expand">
                      <h4 className="uk-card-title">Lista de Estabelecimentos</h4>
                    </Section>
        
                    <Section className="uk-width-auto">
                      <Grid className="uk-flex uk-flex-right">
                        <Section>
                          <button className="uk-button uk-button-link" type="button" onClick={() => AbreModalCadastroEstabelecimento()}>
                            <span uk-icon="icon: plus-box"></span> Novo Estabelecimento
                          </button>
                        </Section>

                        <Section>
                          {LoadingExportar ?
                          <button className="uk-button uk-button-link" type="button" disabled="disabled"><span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde</button>
                          :
                          <button className="uk-button uk-button-link" type="button" onClick={() => ExportarDados()}> <span uk-icon="icon: cloud-download"></span> Exportar </button>
                          }
                        </Section>
                      </Grid>
                    </Section>
                  </Grid>
                </CardHeader>

            { !ListaEstabelecimento ?
						<CardBody> <Loading /> </CardBody> 
            :
						<>
							<CardBody className="uk-child-width-expand@s uk-padding-small">
								<Section className="uk-margin-remove uk-padding-small uk-padding-remove-left uk-padding-remove-right">
									<div className="uk-overflow-auto">
										<table className="uk-table uk-table-divider uk-table-striped uk-table-small uk-text-small uk-table-middle  uk-table-hover">                                        
											<thead>
												<tr>  
													<th className="uk-text-left uk-table-expand">CNPJ</th> 
													<th className="uk-text-left uk-table-expand">Razão Social</th> 
													<th className="uk-text-left uk-table-expand">Nome Fantasia</th> 
													<th className="uk-text-left uk-table-expand">E-mail</th> 
													<th className="uk-text-left uk-table-expand">Telefone</th> 
													<th className="uk-text-left uk-table-expand">Status</th> 
													<th className="uk-text-left uk-table-expand">Data Cadastro</th> 
													<th className="uk-text-center uk-table-shrink">Ação</th> 
												</tr>
											</thead>                              
										<tbody>  
										{
											ListaEstabelecimento.length > 0 ?                              
												ListaEstabelecimento.map((item, index) => {                                      

													return(                                
														<tr key={index}> 
															<td className="uk-text-nowrap"> <strong>{formatCnpjCpf(item.cnpj)}</strong> </td>  		
															<td className="uk-text-nowrap">{item.razaoSocial}</td>
															<td className="uk-text-nowrap">{item.nomeFantasia || '-'}</td>
															<td className="uk-text-nowrap">{item.email}</td>
															<td className="uk-text-nowrap">{item.dddTelefoneComercial} {item.telefoneComercial}</td>
															<td>
																{ item.statusId === 22076  && <span className="uk-label uk-label-success uk-text-capitalize">{item.statusDescricao}</span> }
																{ item.statusId === 22077  && <span className="uk-label uk-label-danger uk-text-capitalize">{item.statusDescricao}</span> } 											
															</td> 
															<td className="uk-text-nowrap">{DateFormatTNew(item.dataCad)}</td>
                              
															<td className="uk-text-nowrap">
																  {(item.statusId === 22076) && <button className="uk-icon-button" uk-icon="icon: ban" uk-tooltip="title: Bloquear" onClick={() => AbreModalStatusEstabelecimento(item)} />}
  																{item.statusId === 22077  && <button className="uk-icon-button" uk-icon="icon: unlock" uk-tooltip="title: Desbloquear" onClick={() => AbreModalStatusEstabelecimento(item)} />}
                              </td>
														</tr>
													) 
												})
											:
												<tr className="uk-text-center">
													<td colSpan={10}>
													{mensagem}
													</td>
												</tr>
										}                                        
										</tbody>
									</table>
									</div>                          
								</Section>                    
							</CardBody>                          
							{
								ListaEstabelecimento.length > 15 &&  
								<CardFooter>
									<Grid className="uk-grid-small uk-flex uk-flex-middle uk-flex-right">
									<>
										<Section className="uk-flex uk-flex-middle">                      
										<span className="uk-margin-small-right">Itens por Página:</span>
										<InputContainer className="uk-form-controls">
											<select className="uk-select" id="form-horizontal-select" onChange={(e) => {SetItensPerPage(e.target.value); SetCurrentPage(1)}}>
												<option value={25} selected={itensPerPage === "25" ? "selected" : ""}>25</option>
												<option value={50} selected={itensPerPage === "50" ? "selected" : ""}>50</option>
												<option value={75} selected={itensPerPage === "75" ? "selected" : ""}>75</option>   
												<option value={100} selected={itensPerPage === "100" ? "selected" : ""}>100</option>                                        
											</select>
										</InputContainer>
										</Section>

										<Section>
										<>										

										<ReactPaginate
												nextLabel=" >"                                  
												onClick={(e) => MudaPaginaItens(e)}                                         
												pageRangeDisplayed={3}
												marginPagesDisplayed={1}
												forcePage={currentPage - 1}
												pageCount={pageCount}
												hrefAllControls={true}
												previousLabel="< "
												pageClassName="page-item"
												pageLinkClassName="page-link"
												previousClassName="page-item"
												// previousLinkClassName="page-link"
												nextClassName="page-item"
												// nextLinkClassName="page-link"
												breakLabel="..."
												breakClassName="page-item"
												breakLinkClassName="page-link"
												containerClassName="uk-pagination"
												activeClassName="uk-active"
												renderOnZeroPageCount={null}
											/>
										</>
										</Section>
									</> 
									</Grid>                                   
								</CardFooter>
							}
						</>
            }
              </Card>
        
          </Section>
        </main>
      </Container>  

      <Modal isOpen={ModalAlteraStatus} centered id="sm">
        <ModalHeader>{'Alteração de Status'}</ModalHeader>

        <ModalBody>         
          <p className="uk-margin-bottom">Tem certeza que deseja alterar o status do estabelecimento <strong>{DadosEstabelecimento?.razaoSocial}</strong>?</p>  
        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button type="button" className="uk-button uk-button-default" onClick={() => FechaModalStatusEstabelecimento()}>
                <span uk-icon="icon: close"></span> Cancelar
              </button>
            </Section>
            <Section>
                <button type="button" id="deletar" className="uk-button uk-button-primary" onClick={() => AlterarStatusEstabelecimento(DadosEstabelecimento)}>
                  <span uk-icon="icon: check"></span> SIM! Alterar Status
                </button>      
                        
                <button className="uk-button uk-button-primary" id="aguardeDelet" style={{display:'none'}} disabled>
                  <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                </button>
              </Section>
          </Grid>
        </ModalFooter>
      </Modal>

      <Modal isOpen={ModalCadastroEstabelecimento} id="lg" centered>
        <ModalHeader>Cadastro de Estabelecimento</ModalHeader>

        <ModalBody>
          <Grid className="uk-grid-small">

            <Section className="uk-width-1-1@m">
              <InputContainer>
                <FormLabel className="uk-form-label">CNPJ <span className="uk-text-danger">*</span></FormLabel>
                <InputMask 
                  mask="99.999.999/9999-99" 
                  maskChar=" " 
                  value={DadosCadastro?.cnpj || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, cnpj: e.target.value })} >                 
                  {() => (<input type="text" className="uk-input input" placeholder='Informe o CNPJ' />)}
                </InputMask>
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Razão Social <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe a Razão Social'
                  type="text"
                  value={DadosCadastro?.razaoSocial || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, razaoSocial: e.target.value })} />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Nome Fantasia <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o Nome Fantasia'
                  type="text"
                  value={DadosCadastro?.nomeFantasia || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, nomeFantasia: e.target.value })}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">E-mail <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o E-mail'
                  type="text"
                  value={DadosCadastro?.email || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, email: e.target.value })}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Telefone <span className="uk-text-danger">*</span></FormLabel>
                <InputMask mask="(99) 999999999" maskChar=" " value={DadosCadastro?.telefone || ''} onChange={e => setDadosCadastro({ ...DadosCadastro, telefone: e.target.value })} >
                  {() => (<input type="text" className="uk-input input" placeholder='Informe o Telefone' />)}
                </InputMask>
              </InputContainer>
            </Section>

            <Section className="uk-width-1-1@m">
              <hr className="uk-divider-icon"></hr>
            </Section>

            <Section className="uk-width-1-3@m">
              <InputContainer>
                <FormLabel className="uk-form-label">CEP <span className="uk-text-danger">*</span></FormLabel>
                <div className="uk-inline" style={{width: '100%'}}>

                  {LoadingCEP ?
                    <span uk-spinner="ratio: 0.5" className="uk-form-icon uk-form-icon-flip"></span>
                  :
                    <a className="uk-form-icon uk-form-icon-flip" onClick={() => ConsultaCEP(DadosCadastro?.cep)} uk-icon="icon: search"></a>
                  }

                  <InputMask mask="99999-999" maskChar=" " value={DadosCadastro?.cep || ''} onChange={(e) => setDadosCadastro({ ...DadosCadastro, cep: e.target.value })} disabled={LoadingCEP}>
                    {() => (<input type="text" className="uk-input input" placeholder='' disabled={LoadingCEP} />)}
                  </InputMask>
                </div>
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m"></Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Endereço <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o Endereço'
                  type="text"
                  value={DadosCadastro?.endereco || ''}
                  disabled={LoadingCEP}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Número <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o Número'
                  type="text"
                  value={DadosCadastro?.numero || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, numero: e.target.value.replace(/[^0-9]/g, '') })}
                  disabled={LoadingCEP}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Complemento</FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o Complemento'
                  type="text"
                  value={DadosCadastro?.complemento || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, complemento: e.target.value })}
                  disabled={LoadingCEP}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Bairro <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o Bairro'
                  type="text"
                  value={DadosCadastro?.bairro || ''}
                  disabled={LoadingCEP}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Cidade <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe a Cidade'
                  type="text"
                  value={DadosCadastro?.cidade || ''}
                  disabled={LoadingCEP}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Estado <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o Estado'
                  type="text"
                  value={DadosCadastro?.estado || ''}
                  disabled={LoadingCEP}
                />
              </InputContainer>
            </Section>
                
          </Grid>
        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button
                type="button"
                id='btn-fechar-cadastro'
                className="uk-button uk-button-danger"
                onClick={() => { FechaModalCadastroEstabelecimento() }}
              >
                <span uk-icon="icon: close"></span> Fechar
              </button>
            </Section>
            <Section>
              <button
                type="button"
                id="btn-envia-formulario"
                className="uk-button uk-button-primary"
                onClick={() => CadastrarEstabelecimento()}
              >
                <span uk-icon="icon: check"></span> Cadastrar
              </button>

              <button className="uk-button uk-button-primary" id="btn-envia-formulario-loading" >
                <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
              </button>
            </Section>
          </Grid>
        </ModalFooter>
      </Modal>

    </Cont>
  );
}

export default Estabelecimentos;
